import { Component, computed, inject, input } from '@angular/core';

import { CmsCollection } from '@fcom/core-api';
import { safeMap } from '@fcom/core/utils/utils';
import { QuickLink } from '@fcom/ui-components/components/quick-links/interfaces';
import { GtmService } from '@fcom/common/gtm/services/gtm.service';
import { ElementTypes } from '@fcom/common';

@Component({
  selector: 'cms-quick-links',
  templateUrl: './cms-quick-links.component.html',
  standalone: false,
})
export class CmsQuickLinksComponent {
  private gtmService = inject(GtmService);

  content = input.required<CmsCollection>();

  links = computed<QuickLink[]>(() => {
    const items = safeMap(this.content(), (c: CmsCollection) => c.items) ?? [];
    return items.map((item) => ({
      title: item.teaserTitle,
      iconName: item.localSettings?.iconName as QuickLink['iconName'],
      url: item.target?.url,
      external: item.target?.external,
    }));
  });

  clickLink(link: QuickLink): void {
    this.gtmService.trackElement(`quick-links: ${link.title}`, 'front-page', ElementTypes.LINK, link.url, 'click');
  }
}
